import styled from '@emotion/styled';

export const ApptErrorModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  @media screen and (max-width: 576px) {
    padding: 1.5rem;
  }
`;
